var React = require('react');

function CaretInline (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"points":"96 48 176 128 96 208","fill":"none","stroke":"current","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"34"}));
}

CaretInline.defaultProps = {"width":"50","height":"50","viewBox":"0 0 256 256"};

module.exports = CaretInline;

CaretInline.default = CaretInline;
